
import React from 'react';
import './styles.css';

function FirstAnimatedContainer({ children }) {
  return <div className="first-animated-container">{children}</div>;
}

export default FirstAnimatedContainer;
